import { useEffect, useRef } from "react";

// Can pass state or props here for previous value
export function usePreviousProps(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
